import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { images } from '../../constants';
import './About.scss';
import { urlFor, client } from '../../client';

// const about = [
//  { title: 'Music', description: 'i am the lead guitarist of Sundara Karma, blah akaja alaha alah skjdsh alsajhd akjshd aksjhd kasjhd dehfgsjhd sjhgksajdh edje', imgUrl: images.guitar },
//  { title: 'Photography', description: 'before the band became my full time thing, i was working as a night club photographer in reading night clubs. etc etc  ', imgUrl: images.gas_state },
//  { title: 'Web Development', description: 'im new to this', imgUrl: images.pc },
//  { title: 'Intrest in Blockchain Debelopment', description: 'i am interested in gaining a deeper understanding of blockchain based app development. i have started with minting mt very own token.', imgUrl: images.about04}
//];

const About = () => {

  const [abouts, setAbouts] = useState([]);  

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query)
      .then((data) => {
        setAbouts(data);

      } )

  }, []);
  
  

  return (
    <>
    <h2 className='head-text'>about<span></span><br /><span> me</span>
    </h2>

    <div className='app__profiles'>
      {abouts.map((about, index) => ( 
        <motion.div
          whileInView={{opacity: 1}}
          whileHover={{ scale: 1.1}}
          transition={{duration: 0.5, type: 'tween'}}
          className='app__profile-item'
          key={about.title + index}
        >
          <img src={urlFor(about.imgUrl)} alt={about.title} />
          <h2 className='bold text' style={{marginTop: 20}}> {about.title} </h2>
          <p className='p-text' style={{marginTop: 10}}> {about.description} </p>
          
        </motion.div>


      ))}  
    </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  
);